import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }
  getLastLoginTime(){
  	return parseInt(localStorage.getItem('lastAct'));
  }
  setLastLoginTime(){
  	var d = new Date(), curTime = d.getTime();
  	localStorage.setItem('lastAct', (curTime+(1800*1000)).toString());
  }
  chkLoginTime(){
  	var lastAct = parseInt(localStorage.getItem('lastAct'));
     if (lastAct !== null && lastAct !== undefined) {
      var d = new Date();
      var  curTime = d.getTime();
      if(lastAct > curTime){
        this.setLastLoginTime();
        return true;
      } else {
        localStorage.clear();
        return false;
      }
     } else {
      localStorage.clear();
      return false;
    }
  }
}
